import { produce } from "immer";

const shippingMethodsReducer = (
    state = {
        loading: false,
        methods: [],
        currentMethod: null,
        error: null,
        countriesRegions: null,
        countriesRegionsLoading: false,
        countriesRegionsError: null,
        showAddForm: false,
    },
    action
) => {
    switch (action.type) {
        case "GET_SHIPPING_METHODS_REQUEST":
            return produce(state, (draft) => {
                draft.loading = true;
                draft.error = null;
            });
        case "GET_SHIPPING_METHODS_SUCCESS":
            return produce(state, (draft) => {
                draft.methods = Array.isArray(action.payload) ? action.payload : [];
                draft.loading = false;
                draft.error = null;
            });
        case "GET_SHIPPING_METHODS_FAILURE":
            return produce(state, (draft) => {
                draft.loading = false;
                // Store error message as string instead of Error object for serialization
                draft.error = action.payload instanceof Error 
                    ? action.payload.message || 'Failed to fetch shipping methods'
                    : (typeof action.payload === 'string' ? action.payload : 'Failed to fetch shipping methods');
            });
        case "GET_SHIPPING_METHOD_REQUEST":
            return produce(state, (draft) => {
                draft.loading = true;
                draft.error = null;
            });
        case "GET_SHIPPING_METHOD_SUCCESS":
            return produce(state, (draft) => {
                draft.currentMethod = action.payload;
                draft.loading = false;
                draft.error = null;
            });
        case "GET_SHIPPING_METHOD_FAILURE":
            return produce(state, (draft) => {
                draft.loading = false;
                // Store error message as string instead of Error object for serialization
                draft.error = action.payload instanceof Error 
                    ? action.payload.message || 'Failed to fetch shipping method'
                    : (typeof action.payload === 'string' ? action.payload : 'Failed to fetch shipping method');
            });
        case "CREATE_SHIPPING_METHOD_REQUEST":
            return produce(state, (draft) => {
                draft.loading = true;
                draft.error = null;
            });
        case "CREATE_SHIPPING_METHOD_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (action.payload && draft.methods) {
                    draft.methods.push(action.payload);
                }
            });
        case "CREATE_SHIPPING_METHOD_FAILURE":
            return produce(state, (draft) => {
                draft.loading = false;
                // Store error message as string instead of Error object for serialization
                draft.error = action.payload instanceof Error 
                    ? action.payload.message || 'Failed to create shipping method'
                    : (typeof action.payload === 'string' ? action.payload : 'Failed to create shipping method');
            });
        case "UPDATE_SHIPPING_METHOD_REQUEST":
            return produce(state, (draft) => {
                draft.loading = true;
                draft.error = null;
            });
        case "UPDATE_SHIPPING_METHOD_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (draft.methods && action.payload) {
                    const idx = draft.methods.findIndex(
                        (method) => method.id === action.payload.id
                    );
                    if (idx !== -1) {
                        draft.methods[idx] = action.payload;
                    }
                }
                if (draft.currentMethod && action.payload?.id === draft.currentMethod.id) {
                    draft.currentMethod = action.payload;
                }
            });
        case "UPDATE_SHIPPING_METHOD_FAILURE":
            return produce(state, (draft) => {
                draft.loading = false;
                // Store error message as string instead of Error object for serialization
                draft.error = action.payload instanceof Error 
                    ? action.payload.message || 'Failed to update shipping method'
                    : (typeof action.payload === 'string' ? action.payload : 'Failed to update shipping method');
            });
        case "DELETE_SHIPPING_METHOD_REQUEST":
            return produce(state, (draft) => {
                draft.loading = true;
                draft.error = null;
            });
        case "DELETE_SHIPPING_METHOD_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                // action.payload is the methodId (number or string)
                const methodId = action.payload;
                if (draft.methods) {
                    draft.methods = draft.methods.filter(
                        (method) => (method.shipping_method_id || method.id) !== methodId
                    );
                }
                if (draft.currentMethod && (draft.currentMethod.shipping_method_id || draft.currentMethod.id) === methodId) {
                    draft.currentMethod = null;
                }
            });
        case "DELETE_SHIPPING_METHOD_FAILURE":
            return produce(state, (draft) => {
                draft.loading = false;
                // Store error message as string instead of Error object for serialization
                draft.error = action.payload instanceof Error 
                    ? action.payload.message || 'Failed to delete shipping method'
                    : (typeof action.payload === 'string' ? action.payload : 'Failed to delete shipping method');
            });
        case "GET_COUNTRIES_REGIONS_REQUEST":
            return produce(state, (draft) => {
                draft.countriesRegionsLoading = true;
                draft.countriesRegionsError = null;
            });
        case "GET_COUNTRIES_REGIONS_SUCCESS":
            return produce(state, (draft) => {
                draft.countriesRegions = action.payload;
                draft.countriesRegionsLoading = false;
                draft.countriesRegionsError = null;
            });
        case "GET_COUNTRIES_REGIONS_FAILURE":
            return produce(state, (draft) => {
                draft.countriesRegionsLoading = false;
                draft.countriesRegionsError = action.payload;
            });
        case "OPEN_SHIPPING_METHOD_FORM":
            return produce(state, (draft) => {
                draft.showAddForm = true;
            });
        case "CLOSE_SHIPPING_METHOD_FORM":
            return produce(state, (draft) => {
                draft.showAddForm = false;
            });
        default:
            return state;
    }
};

export default shippingMethodsReducer;

